/* global $ */


  $(function () {

    //flush header to top of page with transparent bg
    if ($('#site-header').attr('data-flush-header') == 'true') {
    $('#PageContainer').addClass('flush--enabled');
  }
  else {
      $('#PageContainer').addClass('flush--disabled');


  }
    //enable bar
    //true/keep on scroll
    //site content flush to top
    if ( ($("#annoucement__bar").hasClass("annoucement__bar--true scroll--true"))
    && ($('#site-header').attr('data-flush-header') == 'true')  ) {
          $("#PageContainer").addClass('ac');
}
//enable bar
//hide bar on scroll
//site content flush to top

          if ( ($("#annoucement__bar").hasClass("annoucement__bar--true scroll--false"))
          && ($('#site-header').attr('data-flush-header') == 'true')  ) {
                $("#PageContainer").addClass('ac');

              }

              //enable bar
              //true bar on scroll
              //site content NOT flush to top


                if ( ($("#annoucement__bar").hasClass("annoucement__bar--true scroll--true"))
                && ($('#site-header').attr('data-flush-header') == 'false')  ) {
                      $("#PageContainer").addClass('ar');
                      $(".header__container").addClass('solid');
            }

            //enable bar
            //hide bar on scroll
            //site content not flush to top

            if ( ($("#annoucement__bar").hasClass("annoucement__bar--true scroll--false"))
            && ($('#site-header').attr('data-flush-header') == 'false')  ) {
                  $("#PageContainer").addClass('ar');
                  $(".header__container").addClass('solid');
        }
        //disable bar
        //
        //site content flush to top

            if ( ($("#annoucement__bar").hasClass("annoucement__bar--false"))
            && ($('#site-header').attr('data-flush-header') == 'true')  ) {
                  $("#PageContainer").addClass('pp');
        }

        //disable bar
        //
        //site content NOT flush to top

        if ( ($("#annoucement__bar").hasClass("annoucement__bar--false"))
        && ($('#site-header').attr('data-flush-header') == 'false')  ) {
              $("#PageContainer").addClass('ad');
                  $(".header__container").addClass('solid');
    }


});


//Change HEADER on scroll down
$(function() {
  var header = $("#site-header");

  $(window).scroll(function() {
    var scroll = $(window).scrollTop();

    if (scroll >= 40) {
      header.removeClass('defaultHeader').addClass("scrolledHeader");


    } else {
      header.removeClass("scrolledHeader").addClass('defaultHeader');

    }
  });
});

//mobile menu - slide out

$('.moveup').click(function() {
  $('.mobile-nav').addClass('menu-mobile-animate');
});

$('.moveout').click(function() {
  $('.mobile-nav').removeClass('menu-mobile-animate');
});


// add to cart from home and collection pages
function AddToBagGrid($id) {
  var quantity = '1';//add quantity selector here
  var id= $id;// variant selector here
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: {id:id,quantity:quantity},
    success: function(){
      $(".js-drawer-open-button-right").trigger("click");
    }
  });
};

//faqs accordian
//faqs accordion
if (jQuery(".toggle .toggle-title").hasClass('active')) {
  jQuery(".toggle .toggle-title.active").closest('.toggle').find('.toggle-inner').show();
}
jQuery(".toggle .toggle-title").click(function () {
  if (jQuery(this).hasClass('active')) {
    jQuery(this).removeClass("active").closest('.toggle').find('.toggle-inner').slideUp(200);
  }
  else {
    jQuery(this).addClass("active").closest('.toggle').find('.toggle-inner').slideDown(200);
  }
});


//facebook pixel
